"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortBy = sortBy;
exports.findDups = findDups;
exports.uniqueBy = uniqueBy;
exports.uniqueByOrThrow = uniqueByOrThrow;
exports.groupBy = groupBy;
exports.partitionBySize = partitionBySize;
const maps_1 = require("./maps");
function sortBy(input, primaryKey, ...secondaryKeys) {
    return [...input].sort((a, b) => {
        let n = comp(a, b, primaryKey);
        if (n !== 0) {
            return n;
        }
        for (const f of secondaryKeys) {
            n = comp(a, b, f);
            if (n !== 0) {
                return n;
            }
        }
        return 0;
    });
}
function comp(a, b, key) {
    const ak = key(a);
    const bk = key(b);
    if (typeof ak === 'string' && typeof bk === 'string') {
        return ak.localeCompare(bk);
    }
    if (typeof ak === 'number' && typeof bk === 'number') {
        return ak - bk;
    }
    throw new Error(`Cannot compare ${ak} and ${bk}`);
}
function findDups(input, key) {
    const counts = new Map();
    const collidingKeys = new Set();
    const pairs = [];
    for (const item of Array.from(input)) {
        const k = key(item);
        pairs.push([item, k]);
        const n = (0, maps_1.mapIncrement)(counts, k, 1);
        if (n > 1) {
            collidingKeys.add(k);
        }
    }
    const ret = [];
    for (const [item, k] of pairs) {
        if (collidingKeys.has(k)) {
            ret.push(item);
        }
    }
    return ret;
}
function uniqueBy(input, key) {
    const seen = new Set();
    return Array.from(input).filter(item => {
        const k = key(item);
        if (seen.has(k)) {
            return false;
        }
        seen.add(k);
        return true;
    });
}
function uniqueByOrThrow(input, key) {
    const seen = new Set();
    return Array.from(input).filter(item => {
        const k = key(item);
        if (seen.has(k)) {
            throw new Error(`duplicate entry: ${k}`);
        }
        seen.add(k);
        return true;
    });
}
function groupBy(input, key) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const ret = {};
    for (const item of Array.from(input)) {
        const k = key(item);
        let arr = ret[k];
        if (!arr) {
            arr = new Array();
            ret[k] = arr;
        }
        arr.push(item);
    }
    return ret;
}
function partitionBySize(input, size) {
    if (size <= 0) {
        throw new Error('Partition size must be greater than 0');
    }
    const asArray = Array.from(input);
    const result = [];
    for (let i = 0; i < asArray.length; i += size) {
        result.push(asArray.slice(i, i + size));
    }
    return result;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXJyYXlzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FycmF5cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQVVBLHdCQW9CQztBQWlCRCw0QkF3QkM7QUFFRCw0QkFVQztBQUVELDBDQVVDO0FBRUQsMEJBbUJDO0FBRUQsMENBYUM7QUFuSUQsaUNBQXFDO0FBVXJDLFNBQWdCLE1BQU0sQ0FDcEIsS0FBeUMsRUFDekMsVUFBMkIsRUFDM0IsR0FBRyxhQUFnQztJQUVuQyxPQUFPLENBQUMsR0FBRyxLQUFLLENBQUMsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxFQUFFLEVBQUU7UUFDOUIsSUFBSSxDQUFDLEdBQUcsSUFBSSxDQUFDLENBQUMsRUFBRSxDQUFDLEVBQUUsVUFBVSxDQUFDLENBQUE7UUFDOUIsSUFBSSxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUM7WUFDWixPQUFPLENBQUMsQ0FBQTtRQUNWLENBQUM7UUFFRCxLQUFLLE1BQU0sQ0FBQyxJQUFJLGFBQWEsRUFBRSxDQUFDO1lBQzlCLENBQUMsR0FBRyxJQUFJLENBQUMsQ0FBQyxFQUFFLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQTtZQUNqQixJQUFJLENBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQztnQkFDWixPQUFPLENBQUMsQ0FBQTtZQUNWLENBQUM7UUFDSCxDQUFDO1FBRUQsT0FBTyxDQUFDLENBQUE7SUFDVixDQUFDLENBQUMsQ0FBQTtBQUNKLENBQUM7QUFFRCxTQUFTLElBQUksQ0FBSSxDQUFJLEVBQUUsQ0FBSSxFQUFFLEdBQW9CO0lBQy9DLE1BQU0sRUFBRSxHQUFHLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQTtJQUNqQixNQUFNLEVBQUUsR0FBRyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUE7SUFFakIsSUFBSSxPQUFPLEVBQUUsS0FBSyxRQUFRLElBQUksT0FBTyxFQUFFLEtBQUssUUFBUSxFQUFFLENBQUM7UUFDckQsT0FBTyxFQUFFLENBQUMsYUFBYSxDQUFDLEVBQUUsQ0FBQyxDQUFBO0lBQzdCLENBQUM7SUFFRCxJQUFJLE9BQU8sRUFBRSxLQUFLLFFBQVEsSUFBSSxPQUFPLEVBQUUsS0FBSyxRQUFRLEVBQUUsQ0FBQztRQUNyRCxPQUFPLEVBQUUsR0FBRyxFQUFFLENBQUE7SUFDaEIsQ0FBQztJQUVELE1BQU0sSUFBSSxLQUFLLENBQUMsa0JBQWtCLEVBQUUsUUFBUSxFQUFFLEVBQUUsQ0FBQyxDQUFBO0FBQ25ELENBQUM7QUFFRCxTQUFnQixRQUFRLENBQ3RCLEtBQWlDLEVBQ2pDLEdBQW1CO0lBRW5CLE1BQU0sTUFBTSxHQUFHLElBQUksR0FBRyxFQUFhLENBQUE7SUFDbkMsTUFBTSxhQUFhLEdBQUcsSUFBSSxHQUFHLEVBQUssQ0FBQTtJQUNsQyxNQUFNLEtBQUssR0FBYSxFQUFFLENBQUE7SUFDMUIsS0FBSyxNQUFNLElBQUksSUFBSSxLQUFLLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUM7UUFDckMsTUFBTSxDQUFDLEdBQUcsR0FBRyxDQUFDLElBQUksQ0FBQyxDQUFBO1FBQ25CLEtBQUssQ0FBQyxJQUFJLENBQUMsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxDQUFDLENBQUMsQ0FBQTtRQUNyQixNQUFNLENBQUMsR0FBRyxJQUFBLG1CQUFZLEVBQUMsTUFBTSxFQUFFLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQTtRQUNwQyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQztZQUNWLGFBQWEsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUE7UUFDdEIsQ0FBQztJQUNILENBQUM7SUFFRCxNQUFNLEdBQUcsR0FBUSxFQUFFLENBQUE7SUFDbkIsS0FBSyxNQUFNLENBQUMsSUFBSSxFQUFFLENBQUMsQ0FBQyxJQUFJLEtBQUssRUFBRSxDQUFDO1FBQzlCLElBQUksYUFBYSxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDO1lBQ3pCLEdBQUcsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUE7UUFDaEIsQ0FBQztJQUNILENBQUM7SUFFRCxPQUFPLEdBQUcsQ0FBQTtBQUNaLENBQUM7QUFFRCxTQUFnQixRQUFRLENBQU8sS0FBaUMsRUFBRSxHQUFtQjtJQUNuRixNQUFNLElBQUksR0FBRyxJQUFJLEdBQUcsRUFBSyxDQUFBO0lBQ3pCLE9BQU8sS0FBSyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLEVBQUU7UUFDckMsTUFBTSxDQUFDLEdBQUcsR0FBRyxDQUFDLElBQUksQ0FBQyxDQUFBO1FBQ25CLElBQUksSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDO1lBQ2hCLE9BQU8sS0FBSyxDQUFBO1FBQ2QsQ0FBQztRQUNELElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUE7UUFDWCxPQUFPLElBQUksQ0FBQTtJQUNiLENBQUMsQ0FBQyxDQUFBO0FBQ0osQ0FBQztBQUVELFNBQWdCLGVBQWUsQ0FBTyxLQUFpQyxFQUFFLEdBQW1CO0lBQzFGLE1BQU0sSUFBSSxHQUFHLElBQUksR0FBRyxFQUFLLENBQUE7SUFDekIsT0FBTyxLQUFLLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsRUFBRTtRQUNyQyxNQUFNLENBQUMsR0FBRyxHQUFHLENBQUMsSUFBSSxDQUFDLENBQUE7UUFDbkIsSUFBSSxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUM7WUFDaEIsTUFBTSxJQUFJLEtBQUssQ0FBQyxvQkFBb0IsQ0FBQyxFQUFFLENBQUMsQ0FBQTtRQUMxQyxDQUFDO1FBQ0QsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQTtRQUNYLE9BQU8sSUFBSSxDQUFBO0lBQ2IsQ0FBQyxDQUFDLENBQUE7QUFDSixDQUFDO0FBRUQsU0FBZ0IsT0FBTyxDQUNyQixLQUFpQyxFQUNqQyxHQUFtQjtJQUVuQix5RUFBeUU7SUFDekUsTUFBTSxHQUFHLEdBQW1CLEVBQW9CLENBQUE7SUFFaEQsS0FBSyxNQUFNLElBQUksSUFBSSxLQUFLLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUM7UUFDckMsTUFBTSxDQUFDLEdBQUcsR0FBRyxDQUFDLElBQUksQ0FBQyxDQUFBO1FBQ25CLElBQUksR0FBRyxHQUFHLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQTtRQUNoQixJQUFJLENBQUMsR0FBRyxFQUFFLENBQUM7WUFDVCxHQUFHLEdBQUcsSUFBSSxLQUFLLEVBQUssQ0FBQTtZQUNwQixHQUFHLENBQUMsQ0FBQyxDQUFDLEdBQUcsR0FBRyxDQUFBO1FBQ2QsQ0FBQztRQUVELEdBQUcsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUE7SUFDaEIsQ0FBQztJQUVELE9BQU8sR0FBRyxDQUFBO0FBQ1osQ0FBQztBQUVELFNBQWdCLGVBQWUsQ0FBSSxLQUFpQyxFQUFFLElBQVk7SUFDaEYsSUFBSSxJQUFJLElBQUksQ0FBQyxFQUFFLENBQUM7UUFDZCxNQUFNLElBQUksS0FBSyxDQUFDLHVDQUF1QyxDQUFDLENBQUE7SUFDMUQsQ0FBQztJQUVELE1BQU0sT0FBTyxHQUFHLEtBQUssQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLENBQUE7SUFFakMsTUFBTSxNQUFNLEdBQVUsRUFBRSxDQUFBO0lBQ3hCLEtBQUssSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsR0FBRyxPQUFPLENBQUMsTUFBTSxFQUFFLENBQUMsSUFBSSxJQUFJLEVBQUUsQ0FBQztRQUM5QyxNQUFNLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsQ0FBQyxFQUFFLENBQUMsR0FBRyxJQUFJLENBQUMsQ0FBQyxDQUFBO0lBQ3pDLENBQUM7SUFFRCxPQUFPLE1BQU0sQ0FBQTtBQUNmLENBQUMifQ==